<template>
    <svg
        class="filled-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V15.9113C22 17.0159 21.1046 17.9113 20 17.9113H16L11.875 21L8 17.9113H4C2.89543 17.9113 2 17.0159 2 15.9113L2 6Z"
            fill="var(--palette-gray-90)"
            stroke="var(--palette-gray-90)"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <svg
        class="empty-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V15.9113C22 17.0159 21.1046 17.9113 20 17.9113H16L11.875 21L8 17.9113H4C2.89543 17.9113 2 17.0159 2 15.9113L2 6Z"
            stroke="var(--palette-gray-90)"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
